import type { RouteLocation, RouteRecordName } from 'vue-router'

export default (to: RouteLocation, from: RouteLocation) => {
  const summaryPages: RouteRecordName[] = ['Summary', 'SummaryFailure', 'SummaryBankTransfer']
  if (!from.name || summaryPages.includes(from.name)) {
    return {
      name: 'ChildPage',
      params: {
        childEditionId: to?.params?.childEditionId
      }
    }
  }
  return true
}
